import { useDecayTimer } from '@/hooks/useDecayTimer';
import { DEFAULT_DECAY_CURVE, getTierColor, getTierLabel } from '@/lib/decay';
import { scrollToId } from '@/lib/utils';
import { Button } from '@/components/ui/Button';
import { DealCard } from '@/components/ui/DealCard';

export function Hero() {
  const timer = useDecayTimer(DEFAULT_DECAY_CURVE, 10);

  return (
    <section className="flex min-h-screen items-center bg-white">
      <div className="container mx-auto px-6 py-20">
        <div className="flex flex-col items-center gap-12 lg:flex-row lg:gap-16">
          {/* Left - Copy */}
          <div className="flex-1 text-center lg:text-left">
            <h1 className="text-4xl font-extrabold leading-tight text-gray-900 sm:text-5xl md:text-6xl">
              The{' '}
              <span className="text-gradient animate-gradient-shimmer">
                faster
              </span>{' '}
              you get there, the more you save.
            </h1>
            <p className="mt-6 max-w-lg text-lg text-gray-600 lg:max-w-none">
              Flash deals that reward speed. The sooner you arrive, the bigger
              your discount — every minute counts.
            </p>
            <div className="mt-8 flex flex-col gap-4 sm:flex-row sm:justify-center lg:justify-start">
              <Button size="lg" onClick={() => scrollToId('waitlist')}>
                Join the Waitlist
              </Button>
              <Button
                variant="secondary"
                size="lg"
                onClick={() => scrollToId('merchants')}
              >
                I'm a Merchant
              </Button>
            </div>
          </div>

          {/* Right - Live Deal Card */}
          <div className="w-full max-w-sm flex-shrink-0">
            <div className="rounded-3xl bg-gray-900 p-6 shadow-2xl">
              <DealCard
                dealName="Artisan Coffee Roasters"
                originalPrice={24.99}
                currentDiscount={timer.discountPercent}
                tierLabel={getTierLabel(timer.currentTierIndex)}
                tierColor={getTierColor(timer.currentTierIndex)}
                timeRemaining={timer.secondsUntilNextDrop ?? 0}
                compact
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
